<template>
  <div class="useCarApplyContainer">
    <div v-if="!isShowMap" class="useCarApplyContent">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="carInfo.applyTitle" name="1">
          <van-form ref="form">
            <van-cell-group v-if="carInfo.leaderCode">
              <van-field v-model="carInfo.leaderCode" label="工号" placeholder="请输入工号" :rules="[{ required: true }]"
                @change="queryUserName" />
            </van-cell-group>
            <van-cell-group v-if="carInfo.leaderCode">
              <van-field v-model="carInfo.leaderName" label="姓名" placeholder="姓名" readonly />
            </van-cell-group>
            <van-cell-group v-if="carInfo.leaderCode">
              <van-field v-model="carInfo.deptName" label="部门" placeholder="部门" readonly />
            </van-cell-group>
            <van-cell-group>
              <div class="typeContainer">
                <div class="labelTitle">用车类型</div>
                <div class="useCarType">
                  <div class="typeItems" :class="carInfo.useType === index + 1 ? 'typeItemsActive' : ''
                    " v-for="(item, index) in columns" :key="index" @click="selectUseType(item, index + 1)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </van-cell-group>
            <van-cell-group>
              <van-field :readonly="isDisabled" v-model="carInfo.useCost" label="用车成本中心" placeholder="请输入用车成本中心" />
              <div class="hintContent">
                <span>*</span>
                注意：用车的成本中心号需要填写惠州雷士光电科技的成本中心号
              </div>
            </van-cell-group>
            <van-cell-group v-if="carInfo.useType == 2 || carInfo.useType == 3">
              <van-field v-model="carInfo.flightInfo" label="航班信息" placeholder="请输入航班信息" :readonly="isDisabled" />
            </van-cell-group>
            <van-cell-group v-if="carInfo.useType == 2 || carInfo.useType == 3">
              <van-field @click="showArriveTime" readonly :rules="[{ required: true }]"
                v-model="carInfo.expectArrivalTime" label="预计送达时间" placeholder="请输入预计送达时间" />
              <van-popup v-model="showArriveDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" title="选择年月日" :min-date="minDate"
                  @confirm="comfirmArriveTime" @cancel="showArriveDate = false" />
              </van-popup>
            </van-cell-group>
            <van-cell-group>
              <van-field @click="showSaterTime" :readonly="isDisabled" :rules="[{ required: true }]" v-model="carInfo.useSaterTime"
                label="预估开始使用时间" placeholder="请输入预估车辆开始使用时间" />
              <van-popup v-model="showSaterDate" position="bottom">
                <van-datetime-picker v-model="sateDate" type="datetime" title="选择年月日" :min-date="minDate"
                   @confirm="comfirmStare" @cancel="showSaterDate = false" />
              </van-popup>
            </van-cell-group>

            <van-cell-group>
              <van-field @click="showEndTime" :readonly="isDisabled" :rules="[{ required: true }, end()]" v-model="carInfo.useEndTime"
                label="预估结束使用时间" placeholder="请输入预估车辆结束使用时间" />
              <van-popup v-model="showEndDate" position="bottom">
                <van-datetime-picker v-model="endDate" type="datetime" title="选择年月日" :min-date="minDate"
                   @confirm="comfirmEnd" @cancel="showEndDate = false" />
              </van-popup>
            </van-cell-group>
            <!-- @blur="onBlurairportName" -->
            <van-cell-group>
              <van-field :rules="[{ required: true }]" :readonly="isDisabled" v-model="carInfo.airportName"
                :label="carInfo.useType == 2 ? '起点' : carInfo.useType == 3 ? '起点' : '起点'" :placeholder="carInfo.useType == 2
                  ? '请输入起点'
                  : carInfo.useType == 3
                    ? '请输入起点'
                    : '请输入起始地点详细信息'
                  " class="my-field">
                <template #button>
                  <i @click.stop="iconClick('起点')" style="font-size: 24px; color: #4ea27c"
                    class="iconfont icon-mapmarker"></i>
                </template>
              </van-field>
            </van-cell-group>
            <van-cell-group>
              <van-field @click="topathwayPlace" :rules="[{ required: true }]" v-model="carInfo.pathwayPlace" label="终点"
                :readonly="isDisabled" class="my-field" placeholder="请输入终点">
                <template #button>
                  <i style="font-size: 24px; color: #4ea27c" class="iconfont icon-mapmarker"></i>
                </template>
              </van-field>
            </van-cell-group>
            <!-- <van-cell-group>
              <van-field @blur="onBlurdestination" :rules="[{ required: true }]" :readonly="isDisabled"
                v-model="carInfo.destination" label="终点" placeholder="请输入终点详细信息" class="endPlace">
                <template #button>
                  <i @click.stop="iconClick('终点')" style="font-size: 24px; color: #4ea27c"
                    class="iconfont icon-mapmarker"></i>
                </template>
              </van-field>
            </van-cell-group> -->
            <van-cell-group>
              <van-field
                v-model="carInfo.reason"
                rows="3"
                :rules="[{ required: true }]"
                autosize
                label="用车事由"
                type="textarea"
                placeholder="请输入用车事由"
              />
            </van-cell-group>
            <van-cell-group>
              <van-field @click="showUsepropleNum" readonly :rules="[{ required: true }]" v-model="carInfo.useNumber"
                label="用车人数" placeholder="请选择">
                <template #button>
                  <van-icon name="arrow-down" />
                </template>
              </van-field>
              <van-popup v-model="showUsepropleNumSelect" position="bottom">
                <van-picker show-toolbar :columns="useNumber" @confirm="confirmUsePropleNum"
                  @cancel="cancelUsePropleNum" />
              </van-popup>
            </van-cell-group>
            <van-cell-group>
              <van-field :rules="[{ required: true }]" v-model="carInfo.useName" label="联系人" placeholder="请输入联系人姓名"
                :readonly="isDisabled" />
            </van-cell-group>

          <van-cell-group class="carRadio" v-if="zoneId != 1">
            <van-field name="radio" label="是否需要司机">
              <template #input>
                <van-radio-group :disabled="isDisabled" v-model="carInfo.driverType" direction="horizontal">
                  <van-radio name="1">是</van-radio>
                  <van-radio name="2">否</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </van-cell-group>

            <van-cell-group>
              <van-field :rules="[{ required: true, tel }]" v-model="carInfo.usePhone" label="联系人电话"
                placeholder="请输入联系人电话" :readonly="isDisabled">
                <template #button>
                  <a :href="'tel:' + carInfo.usePhone" style="color: #4ea27c">
                    <i style="font-size: 0.6rem;" class="iconfont icon-telephone"></i>
                  </a>
                </template>
              </van-field>
            </van-cell-group>
            <van-cell-group>
              <van-field v-model="carInfo.remarks" rows="3" autosize label="备注（随车物品）" type="textarea"
                placeholder="请输入备注" :readonly="isDisabled" />
            </van-cell-group>
          </van-form>
        </van-collapse-item>
        <van-collapse-item title="公务车信息" name="2">
          <van-cell-group>
            <van-field v-model="carInfo.carBrand" label="车牌" placeholder="请输入车牌" readonly />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.driverName" label="司机姓名" placeholder="请输入司机姓名" readonly />
          </van-cell-group>
          <van-cell-group>
            <van-field v-model="carInfo.driverPhone" label="联系方式" placeholder="请输入联系方式" readonly>
              <template #button v-if="carInfo.driverPhone">
                <a :href="'tel:' + carInfo.usePhone" style="color: #4ea27c">
                  <i style="font-size: 0.6rem;" class="iconfont icon-telephone"></i>
                </a>
              </template>
            </van-field>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
      <van-cell-group style="padding: 0 20px" v-if="!carInfo.leaderCode">
        <div class="flowPath">
          <div class="flowPathTitle">审批流</div>
          <div>
            <div class="container_item">
              <div>
                <div class="handle" v-for="(approve, index) in carInfo.approveList" :key="approve.id">
                  <div class="handleDiv">
                    <img src="@/assets/car/handle.png" alt="" srcset="" style="width: 27px; height: 27px" />
                  </div>
                  <div class="handleRight">
                    <h3 class="rightTitle" v-if="approve.nodeName">
                      <!-- {{ index == 0 ? "直属上级审批" : "审批人" }} -->
                      {{ approve.nodeName }}
                    </h3>
                    <h3 class="rightTitle" v-if="!approve.nodeName">
                      {{ index == 0 ? "直属上级审批" : "审批人" }}
                      <!-- {{ approve.nodeName }} -->
                    </h3>
                    <div class="approver">
                      <div class="approverImg">
                        <span class="clr-span">{{ approve.approveName }}</span>
                      </div>
                      <div class="right">
                        <span style="margin-right: 5px"
                          :style="{ color: (approve.approveState == '通过' ? '#267ef0' : approve.approveState == '驳回' ? 'red' : '') }"
                          v-if="approve.nodeName">

                          <!-- {{approve.approveState == '2' ? '已同意' : approve.approveState == '3' ? '已拒绝' : '' }} -->
                          {{ approve.approveState }}
                        </span>
                        <span style="margin-right: 5px"
                          :style="{ color: (approve.approveState == '2' ? '#267ef0' : approve.approveState == '3' ? 'red' : '') }"
                          v-if="!approve.nodeName">

                          {{ approve.approveState == '2' ? '已同意' : approve.approveState == '3' ? '已拒绝' : '' }}
                          <!-- {{ approve.approveState }} -->
                        </span>
                        <span>{{ approve.approveTime }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-cell-group>
      <div class="footerBtn">
        <div>
          <van-button @click="cancel" type="default" size="small" style="width: 30%">取消</van-button>
          <van-button :disabled="btnloading" type="info" size="small" @click="confirm"
            style="width: 70%; background-color: #4ea27c">确定</van-button>
        </div>
      </div>
    </div>
    <!-- 起点选择地图 -->
    <!-- <div v-if="isShowMap">
      <div v-loading="loading" id="container" style="width: 100%; height: 80vh"></div>
      <div style="position: relative">
        <div class="circle" @click="ready">
          <i style="font-size: 0.7rem" class="iconfont icon-shuaxin"></i>
        </div>
        <div style="font-size: 16px">
          当前选中地址：{{ nowAddressobj.useLocation }}
        </div>
        <van-button style="width: 50%" @click="closeMap" type="default">取消</van-button>
        <van-button style="width: 50%" @click="determineMap" type="info">确认</van-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import "@/assets/car/icon/iconfont.css";
// import AMapLoader from "@amap/amap-jsapi-loader";
// window._AMapSecurityConfig = {
//   securityJsCode: "d7dd8082c27cd068108a8e1b6aed837f"
// };
import moment from "moment";
import "moment/locale/zh-cn";
import "@/assets/car/icon/iconfont.css";
import apis from "@/apis/car.js";
import api from "@/apis";
// const asyncJS = src => {
//   var jsapi = document.createElement("script");
//   jsapi.charset = "utf-8";
//   jsapi.src = src;
//   document.head.appendChild(jsapi);
// };
export default {
  name: "alreadyAllotDetail",
  data() {
    return {
      activeNames: ["1", "2"],
      tel: {
        // 自定义校验规则
        validator: value => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57]|199)[0-9]{8}$/.test(
            value
          );
        },
        message: "请输入正确格式的手机号码",
        trigger: "onBlur"
      },
      carInfo: {
        applyTitle:
          this.$store.state.userInfo.department +
          "-" +
          this.$store.state.userInfo.nickname,
        useType: 1, //用车类型  1,"客户接待" 2,"接机送机" 3,"供应商考虑" 4,"其他"
        useCost: this.$store.state.userInfo.costCenterNo, //用车成本中心
        flightInfo: "", //航班信息
        expectArrivalTime: "", //预计到达时间
        time: "", //预计到达时间
        useSaterTime: "", //使用开始时间
        saterTime: "", //使用开始时间
        useEndTime: "", //使用结束时间
        endTime: "", //使用结束时间
        airportName: "", //起点
        pathwayPlace: "", //途径点
        // destination: "惠州雷士工业园区", //目的地
        destination: "", //目的地
        useNumber: "", //用车人数
        driverType:'',
        useName: this.$store.state.userInfo.nickname, //联系人
        createUser: this.$store.state.userInfo.userid, //申请人工号
        usePhone: this.$store.state.userInfo.phone, //电话
        remarks: "", //备注
        addressInfoList: [], //地址集合
        applyDeptName: this.$store.state.userInfo.department, //部门名称
        airportNameList: [], //起点集合
        destinationList: [
          // {
          //   useLocation: "惠州雷士工业园区",
          //   longitude: 114.337575,
          //   dimension: 23.010305
          // }
        ],//终点集合
        leaderCode: null,//工号
        leaderName: '',//姓名
        deptName: "",//领导部门
        reason:'' // 用车事由
      },
      useSaterTime: "",
      useEndTime: "",
      minDate: new Date(),
      currentDate: new Date(),
      sateDate: new Date(),
      endDate: new Date(),
      showUseTypeSelect: false,
      showUsepropleNumSelect: false,
      showArriveDate: false,
      showSaterDate: false,
      showEndDate: false,
      columns: ["客户接待", "接机", '送机', "供应商考察", "其他"],
      useNumber: ["1", "2", "3", "4", "5", "6"],
      btnloading: false,
      map: null,
      mapMark: null,
      longAndLat: "",
      isShowMap: false,
      nowAddressobj: "",
      iconClickTitle: "",
      loading: true,
      isDisabled: true,
      isReadonly:true,
      zoneId:''
    };
  },
  created() {
    this.btnloading = false;
    const carInfo = sessionStorage.getItem("carInfo");
    if (carInfo) {
      this.carInfo = JSON.parse(carInfo);
      // if (
      //   this.carInfo.airportName
      // ) {
      //   this.search("起点");
      // }
      // if (
      //   this.carInfo.destination
      // ) {
      //   this.search("终点");
      // }
    }
    let addressInfoList = sessionStorage.getItem("addressInfoList")
      ? JSON.parse(sessionStorage.getItem("addressInfoList"))
      : [];
    let pathwayPlace = [];
    if (addressInfoList.length > 0) {
      addressInfoList.filter(item => {
        pathwayPlace.push(item.useLocation);
      });
    }
    this.carInfo.pathwayPlace = pathwayPlace.toString(); //显示途径地名称
    this.carInfo.addressInfoList = addressInfoList;
  },
  mounted() {
    //判断是否只读
    this.isDisabled = this.$route.query.disabled == 'true' ? true : false;
    console.log(this.isDisabled,'this.isDisabled');
    
    if(this.$route.query.disabled == 'true'){
      this.isDisabled = true;
      this.isReadonly = true;
    } else if(this.$route.query.isReadonly == 'true'){
      this.isReadonly = true;
    } else {
      this.isDisabled = false;
    }
    // this.isReadonly = this.$route.query.isReadonly == 'true' ? true : false;
    sessionStorage.removeItem("carInfo");
    this.zoneId = localStorage.getItem("cityId");
    let applyNumber = this.$route.query.applyNumber;
    if (applyNumber) {
      this.postqueryUseCarDetails(applyNumber);
    }
    // asyncJS(
    //   "https://webapi.amap.com/maps?v=1.4.15&key=db734ee0deb249082595ed2fb6f74750&callback=onLoadMap"
    // );
  },
  methods: {
    // ready() {
    //   this.map = new window.AMap.Map("container", {
    //     resizeEnable: true,
    //     zoom: 17 // 将缩放级别设置为17
    //   });

    //   let _this = this;

    //   // 获取当前位置和地址名称
    //   window.AMap.plugin("AMap.Geolocation", () => {
    //     let geolocation = new window.AMap.Geolocation({
    //       enableHighAccuracy: true,
    //       timeout: 10000
    //     });

    //     geolocation.getCurrentPosition((status, result) => {
    //       console.log('status', status);
    //       if (status === "complete") {
    //         let lng = result.position.lng;
    //         let lat = result.position.lat;

    //         _this.longAndLat = lng + "," + lat;

    //         // 在地图上标注当前位置
    //         _this.map.clearMap();

    //         let mapMarker = new window.AMap.Marker({
    //           position: [lng, lat],
    //           map: _this.map
    //         });

    //         _this.map.setCenter(mapMarker.getPosition());
    //         _this.map.setZoom(17); // 将缩放级别设置为17
    //         mapMarker.setMap(_this.map);

    //         // 获取当前地址名称
    //         window.AMap.plugin("AMap.Geocoder", () => {
    //           let geocoder = new window.AMap.Geocoder();

    //           geocoder.getAddress([lng, lat], (status, result) => {
    //             if (status === "complete" && result.info === "OK") {
    //               let address = result.regeocode.formattedAddress;
    //               console.log("当前位置地址：", address, lng, lat);
    //               // 在这里将地址名称赋值给你的变量或进行其他操作
    //               _this.nowAddressobj = {
    //                 useLocation: address,
    //                 longitude: lng,
    //                 dimension: lat
    //               };
    //               this.loading = false;
    //             } else {
    //               // console.log('获取当前位置地址失败');
    //               _this.$toast("获取当前位置地址失败");
    //               _this.nowAddressobj = {};
    //               this.loading = false;
    //             }
    //           });
    //         });
    //       } else {
    //         // console.log('获取当前位置失败');
    //         _this.$toast("获取当前位置失败，请手动点击地图选择");
    //         _this.nowAddressobj = {};
    //         this.loading = false;
    //       }
    //     });
    //   });

    //   this.map.on("click", e => {
    //     let lng = e.lnglat.getLng();
    //     let lat = e.lnglat.getLat();
    //     _this.longAndLat = lng + "," + lat;

    //     // 打新的标记
    //     _this.map.clearMap();

    //     let mapMarker = new window.AMap.Marker({
    //       position: [lng, lat],
    //       map: _this.map
    //     });

    //     _this.map.setCenter(mapMarker.getPosition());
    //     _this.map.setZoom(17); // 将缩放级别设置为17
    //     mapMarker.setMap(_this.map);

    //     // 获取点击位置的地址名称
    //     window.AMap.plugin("AMap.Geocoder", () => {
    //       let geocoder = new window.AMap.Geocoder();

    //       geocoder.getAddress([lng, lat], (status, result) => {
    //         if (status === "complete" && result.info === "OK") {
    //           let address = result.regeocode.formattedAddress;
    //           console.log("点击位置地址：", address, lng, lat);
    //           _this.nowAddressobj = {
    //             useLocation: address,
    //             longitude: lng,
    //             dimension: lat
    //           };
    //           // 在这里将地址名称赋值给你的变量或进行其他操作
    //         } else {
    //           console.log("获取点击位置地址失败");
    //           _this.$toast("获取点击位置地址失败");
    //           _this.nowAddressobj = {};
    //         }
    //       });
    //     });
    //   });
    // },
    // 判断开始时间是否小于结束时间
    end() {
      let saterTime = this.carInfo.saterTime;
      let endTime = this.carInfo.endTime;
      return {
        validator: () => {
          return saterTime
            ? new Date(saterTime).getTime() < new Date(endTime).getTime()
            : true;
        },
        message: "结算时间不能小于开始时间",
        trigger: "onBlur"
      };
    },
    // //起点失去焦点
    // async onBlurairportName() {
    //   if (this.carInfo.airportName) {
    //     await this.search("起点");
    //   }
    // },
    // //终点失去焦点
    // async onBlurdestination() {
    //   if (this.carInfo.destination) {
    //     await this.search("终点");
    //   }
    // },
    //显示人数选择
    showUsepropleNum() {
      this.showUsepropleNumSelect = !this.isDisabled;
    },
    //人数选择确定
    confirmUsePropleNum(value) {
      this.carInfo.useNumber = value;
      this.showUsepropleNumSelect = false;
    },
    // 人数选择取消
    cancelUsePropleNum() {
      this.showUsepropleNumSelect = false;
    },
    //选择用车类型
    selectUseType(item, index) {
      if (!this.isDisabled) {
        this.carInfo.useType = index;
      }

    },
    // 途径点
    topathwayPlace() {
      if (!this.isDisabled) {
        sessionStorage.setItem("carInfo", JSON.stringify(this.carInfo));
        // sessionStorage.setItem("isShowUserId",);

        this.$router.replace({
          path: "/car/official/pathwayPlace",
          query: {
            keyName: "facility",
            name: "alreadyAllotDetail"
          }
        });
      }

    },
    //显示 预计到达时间
    showArriveTime() {
      this.showArriveDate = !this.isDisabled;
    },
    //显示预计开始使用时间
    showSaterTime() {
      this.showSaterDate = !this.isDisabled;
    },
    //显示预计结束使用时间
    showEndTime() {
      this.showEndDate = !this.isDisabled;
    },
    // 确定 时间
    comfirmArriveTime(value) {
      this.carInfo.time = value;
      this.carInfo.expectArrivalTime = moment(value).format(
        "YY年MM月DD日 dddd HH:mm"
      );
      this.showArriveDate = false;
    },
    // 确定 开始时间
    comfirmStare(value) {
      this.carInfo.saterTime = value;
      this.carInfo.useSaterTime = moment(value).format("MM月DD日 dddd HH:mm");
      this.showSaterDate = false;
    },
    // 确定 结束时间
    comfirmEnd(value) {
      this.carInfo.endTime = value;
      this.carInfo.useEndTime = moment(value).format("MM月DD日 dddd HH:mm");
      this.showEndDate = false;
    },
    //返回
    cancel() {
      this.btnloading = false;
      this.$router.go(-1);
    },
    //确认
    confirm() {
      this.$refs.form
        .validate()
        .then(() => {
          if (!this.isDisabled) {
            this.btnloading = true;
            // if (this.carInfo.airportNameList.length == 0)
            //   return this.$toast.fail(
            //     "您填写的" + this.carInfo.useType == 2
            //       ? "接机机场名称"
            //       : this.carInfo.useType == 3
            //         ? "送机机场名称"
            //         : "起点" + "有问题，请检查"
            //   );
            this.postinsertApplyCar();
          } else {
            this.$toast.fail("已完成或已取消或已作废不能修改");
          }
        })
        .catch(() => {
          this.btnloading = false;
          this.$toast.fail("提交失败");
        });
    },
    // search(val) {
    //   let _this = this;
    //   val == "起点"
    //     ? (this.carInfo.airportNameList = [])
    //     : (this.carInfo.destinationList = []);
    //   window.AMap.plugin("AMap.PlaceSearch", () => {
    //     var autoOptions = {
    //       city: "全国",
    //       map: _this.map, // 展现结果的地图实例
    //       pageSize: 1, // 单页显示结果条数
    //       pageIndex: 1, // 页码
    //       autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
    //     };
    //     var placeSearch = new window.AMap.PlaceSearch(autoOptions);
    //     placeSearch.search(
    //       val == "起点" ? this.carInfo.airportName : this.carInfo.destination,
    //       (status, result) => {
    //         // 搜索成功时，result即是对应的匹配数据
    //         if (status == "complete") {
    //           if (result.poiList.pois.length > 0) {
    //             let lng = result.poiList.pois[0].location.lng;
    //             let lat = result.poiList.pois[0].location.lat;
    //             _this.longAndLat = lng + "," + lat;
    //             console.log(val, lng + "," + lat);
    //             val == "起点"
    //               ? this.carInfo.airportNameList.push({
    //                 useLocation:
    //                   val == "起点"
    //                     ? this.carInfo.airportName
    //                     : this.carInfo.destination,
    //                 longitude: lng,
    //                 dimension: lat
    //               })
    //               : this.carInfo.destinationList.push({
    //                 useLocation:
    //                   val == "起点"
    //                     ? this.carInfo.airportName
    //                     : this.carInfo.destination,
    //                 longitude: lng,
    //                 dimension: lat
    //               });
    //           } else {
    //             this.$toast("没有查询到对应的地址");
    //             val == "起点"
    //               ? (this.carInfo.airportName = "")
    //               : (this.carInfo.destination = "");
    //           }
    //         } else if (status == "no_data") {
    //           this.$toast("没有查询到对应的地址");
    //           val == "起点"
    //             ? (this.carInfo.airportName = "")
    //             : (this.carInfo.destination = "");
    //         } else {
    //           this.$toast("免费额度已用完，请购买高德地图api");
    //           val == "起点"
    //             ? (this.carInfo.airportName = "")
    //             : (this.carInfo.destination = "");
    //         }
    //       }
    //     );
    //   });
    // },
    // 根据工号获取姓名
    queryUserName() {
      api.queryByUsername({ username: this.carInfo.leaderCode }).then(res => {
        if (res.code == 200) {
          this.carInfo.leaderName = res.data.nickname;
          this.carInfo.deptName = res.data.department;
          this.carInfo.useName = res.data.nickname;
          this.carInfo.usePhone = res.data.phone;
        }
      });
    },

    //发送申请接口
    postinsertApplyCar() {
      let applyNumber = this.carInfo.applyNumber;
      // let addressInfoList = [].concat(
      //   // this.carInfo.airportNameList,
      //   this.carInfo.addressInfoList,
      //   // this.carInfo.destinationList
      // );
      this.carInfo.addressInfoList = this.carInfo.addressInfoList.map(item => {
        return { useLocation: item.useLocation };
      });
      let obj = {
        useType: this.carInfo.useType,
        applyTitle: this.carInfo.applyTitle,
        useCost: this.carInfo.useCost,
        flightInfo: this.carInfo.useType == "2" || this.carInfo.useType == "3" ? this.carInfo.flightInfo : '',
        expectArrivalTime: this.carInfo.useType == "2" || this.carInfo.useType == "3" ? moment(this.carInfo.time).format("YYYY-MM-DD HH:mm:ss") : "",
        useSaterTime: moment(this.carInfo.saterTime).format("YYYY-MM-DD HH:mm:ss"),
        useEndTime: moment(this.carInfo.endTime).format("YYYY-MM-DD HH:mm:ss"),
        airportName: this.carInfo.airportName,
        destination: this.carInfo.destination,
        useNumber: this.carInfo.useNumber,
        useName: this.carInfo.useName,
        createUser: this.carInfo.createUser,
        usePhone: this.carInfo.usePhone,
        remarks: this.carInfo.remarks,
        applyDeptName: this.carInfo.leaderCode ? this.carInfo.deptName : this.carInfo.applyDeptName,
        addressInfoList: this.carInfo.addressInfoList,
        applyNumber,
        id: this.carInfo.id,
        reason: this.carInfo.reason
        // driverType: this.carInfo.driverType
      };
      if(this.zoneId != 1){
        obj.driverType = this.carInfo.driverType
      }
      if (this.carInfo.leaderCode) {
        obj.leaderCode = this.carInfo.leaderCode;
        obj.leaderName = this.carInfo.leaderName;

      }
      console.log('obj', obj);
      //修改
      apis
        .updateMyApplication(obj)
        .then(res => {
          if (res.code == "200" && res.message == "success") {
            this.$toast.success("修改成功");
            this.$router.go(-1);
            // this.$router.replace({
            //   path: "/car/facility/useCarApply",
            //   query: {
            //     name: 2
            //   }
            // });
          } else {
            this.btnloading = false;
          }
        })
        .catch(() => {
          this.btnloading = false;
          this.$toast.fail("提交失败");
        });
    },
    //查看详情
    postqueryUseCarDetails(applyNumber) {
      this.carInfo.airportNameList = [];
      this.carInfo.destinationList = [];
      apis
        .queryUseCarDetails({ applyNumber })
        .then(res => {
          let carInfo = res.data;
          console.log('res.data', res.data);
          carInfo.time = carInfo.expectArrivalTime
            ? carInfo.expectArrivalTime
            : new Date();
          carInfo.expectArrivalTime = moment(carInfo.time).format(
            "YY年MM月DD日 dddd HH:mm"
          );
          carInfo.saterTime = carInfo.useSaterTime;
          carInfo.useSaterTime = moment(carInfo.saterTime).format(
            "MM月DD日 dddd HH:mm"
          );
          carInfo.endTime = carInfo.useEndTime;
          carInfo.useEndTime = moment(carInfo.endTime).format(
            "MM月DD日 dddd HH:mm"
          );
          this.minDate = new Date(carInfo.saterTime);
          this.currentDate = carInfo.time ? new Date(carInfo.time) : new Date();
          this.sateDate = carInfo.saterTime
            ? new Date(carInfo.saterTime)
            : new Date();
          this.endDate = carInfo.endTime
            ? new Date(carInfo.endTime)
            : new Date();
          carInfo.applyNumber = this.$route.query.applyNumber; //存id
          if (carInfo.addressInfoList.length > 0) {
            carInfo.airportNameList = [res.data.airportName];
            // carInfo.destinationList = [carInfo.addressInfoList.pop()];
            let addressInfoList = carInfo.addressInfoList;
            if (addressInfoList.length > 0) {
              sessionStorage.setItem(
                "addressInfoList",
                JSON.stringify(addressInfoList)
              );
            }

            let pathwayPlace = [];
            carInfo.addressInfoList.filter(item => {
              pathwayPlace.push(item.useLocation);
            });
            carInfo.pathwayPlace = pathwayPlace.toString(); //显示途径地名称
          }
          this.carInfo = carInfo;
          this.carInfo.deptName = carInfo.applyDeptName;
        })
        .catch(() => {
          this.$toast.fail("提交失败");
        });
    },
    //地址图标点击
    // iconClick(val) {
    //   if (!this.isDisabled) {
    //     this.isShowMap = true;
    //     this.iconClickTitle = val;
    //     this.nowAddressobj = {};
    //     // key 值需要去高德地图去申请才可以
    //     asyncJS(
    //       "https://webapi.amap.com/maps?v=1.4.15&key=db734ee0deb249082595ed2fb6f74750&callback=onLoadMap"
    //     );
    //     this.$nextTick(() => {
    //       window.onLoadMap = () => {
    //         console.log('val', val);
    //         this.isShowMap ? this.ready() : '';
    //       };
    //     });
    //   }

    // },
    //关闭地图
    closeMap() {
      this.isShowMap = false;
      this.loading = true;
    },
    //确认地图选择
    determineMap() {
      if (this.iconClickTitle == "起点") {
        this.carInfo.airportName = this.nowAddressobj.useLocation;
        this.carInfo.airportNameList = [this.nowAddressobj];
      } else if (this.iconClickTitle == "终点") {
        this.carInfo.destination = this.nowAddressobj.useLocation;
        this.carInfo.destinationList = [this.nowAddressobj];
      }

      this.isShowMap = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .useCarApplyContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .useCarApplyContainer {
    width: 276px * $zoom;
  }
}

.useCarApplyContainer {
  margin: auto;

  .useCarApplyContent {
    ::v-deep .van-cell__title {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #282b32;
    }

    ::v-deep(.van-cell-group) {
      .van-cell {
        display: flex;
        flex-direction: column;
        padding: 18px 0;
      }

      .van-field__value {
        background-color: #f7f9fa;
        padding: 10px 20px;
      }

      .van-cell::after {
        content: "";
        border-bottom: 0;
      }

      .van-field__label {
        width: 500px !important;
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        margin-bottom: 15px;
      }

      .endPlace .van-field__label::after {
        content: "（默认为公司，有需要可修改）";
        font-size: 16px;
        color: #b5b9bb;
      }
    }

    ::v-deep .van-hairline--top-bottom::after {
      content: "";
      border: 0;
    }

    .typeContainer {
      // padding: 18px 0;

      .labelTitle {
        margin-bottom: 15px;
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
      }

      .useCarType {
        display: flex;
        margin-top: 10px;

        .typeItems {
          padding: 0 10px;
          // width: 160px;
          height: 54px;
          line-height: 54px;
          text-align: center;
          background: #f7f9fa;
          border-radius: 4px;
          margin-right: 20px;
          color: #969b9e;
        }

        .typeItemsActive {
          background-color: #4ea27c;
          color: #fff;
        }
      }
    }

    .userName {
      font-size: 26px;
      padding: 20px 25px;
    }

    .hintContent {
      font-size: 18px;
      padding-bottom: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #969b9e;

      span {
        color: red;
      }
    }

    .flowPath {
      padding: 30px 0;

      .flowPathTitle {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #282b32;
        margin-bottom: 20px;
      }
    }
  }

  .footerBtn {
    padding-top: 30px;
    background-color: #f7f9fa;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }

  .handle {
    display: flex;

    .handle-div {
      position: relative;
    }
  }

  .copy {
    display: flex;

    .copy-div {
      position: relative;
    }
  }

  .clr-span {
    display: inline-block;
    width: 160px;
    border-radius: 20px;
    background-color: rgb(248 250 251);
    margin: 0 5px;
    padding: 10px 0;
    font-size: 32px;
    text-align: center;
  }

  .circle {
    z-index: 2;
    width: 40px;
    height: 40px;
    border-radius: 100px;
    position: absolute;
    top: -200px;
    right: 2%;
    cursor: pointer;
    border-radius: 50%;
    // background-color: rgb(47, 116, 235);
    // animation: blink 5s linear infinite;
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}

.carRadio{
  ::v-deep{
    .van-cell__value{
      background: none !important;
    }
  }
}

.container_item {
  background: #fff;
  margin-top: 20px;
  padding: 25px;

  .title {
    color: rgba(150, 155, 158, 1);
    font-size: 30px;
  }

  .handle {
    display: flex;
    margin-top: 10px;

    &:last-child {
      .handleDiv::after {
        width: 0;
        height: 0;
      }
    }

    .handleDiv::after {
      display: block;
      content: "";
      width: 1px;
      height: 70px;
      background-color: #ccc;
      position: relative;
      left: 24px;
    }

    .handleRight {
      margin-left: 20px;
      width: calc(100vh);

      .rightTitle {
        margin: 10px 0;
        font-size: 29px;
      }

      .approver {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .approverImg {
          display: flex;
          flex-shrink: 0;
          align-items: center;

          .iconWrapper {
            position: relative;

            .elIcon {
              position: absolute;
              left: 40px;
              top: -10px;
              font-size: 22px;
            }
          }

          .clr-span {
            display: inline-block;
            border-radius: 20px;
            background-color: rgb(248 250 251);
            margin: 0 5px;
            padding: 10px 0;
            font-size: 24px;
            text-align: center;
            margin-left: 15px;
          }
        }

        .right {
          flex-shrink: 0;
          // margin-left: 30%;
          font-size: 22px;
          color: #9fa2a5;
        }
      }
    }
  }
}
</style>
